import React from "react";
import './PromiseSection.css';
import BackgroundDecoration from '../../components/BackgroundDecoration/BackgroundDecoration';

/**
 * PromiseSection - Sección para mostrar la promesa de valor
 * Bloque de autoridad que destaca la propuesta única
 */
const PromiseSection = ({ title, description, ctaText, ctaLink, theme = 'dark', backgroundDecoration }) => {
  return (
    <div className={`promiseContainer promiseContainer--${theme}`}>
      {backgroundDecoration && <BackgroundDecoration {...backgroundDecoration} />}
      <div className="promiseContent">
        <div className="promiseMain">
          {title && <h2 className="promiseTitle">{title.toUpperCase()}</h2>}
          {description && <p className="promiseDescription">{description}</p>}
          {ctaText && (
            <a
              href={ctaLink || '#contact'}
              className={`promiseButton pillButton pillButton--on-${theme}`}
            >
              {ctaText.toUpperCase()}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default PromiseSection;
